import React from "react";
import { useLocation } from "react-router-dom";
import CVLAModuleSubtopic from "../CVLAModuleSubtopic";

const MilneThomsonMethod = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <CVLAModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Milne Thomson Method"
      videos={[
        "https://www.youtube.com/embed/ml1IDAC2aCs?list=PLhSp9OSVmeyITvYvCWwrYBiPkzsCNSOWu",
        "https://www.youtube.com/embed/5g5YZ0DRHj8?list=PLhSp9OSVmeyITvYvCWwrYBiPkzsCNSOWu",
        "https://www.youtube.com/embed/o-rg7fhE2vQ?list=PLhSp9OSVmeyITvYvCWwrYBiPkzsCNSOWu"
      ]}
      takeaways={[]}
      questions={[]}
      exampleVideos={[]}
    />
  );
}

export default MilneThomsonMethod;
